import React, { useEffect, useState } from 'react';
import { CenterFrameLayout } from 'Layouts';
import { Navigate, useLocation, matchPath } from 'react-router-dom';
import { setLocation } from 'Utils/Path';
import { useStore } from 'Hooks/useStore';

const REDIRECT_HOME_DELAY = 2000;

export function NotFoundComponent({ title, subMessage }) {
  return (
    <CenterFrameLayout modernLayout title={title}>
      <div className="centerForm alignCenter">{subMessage}</div>
    </CenterFrameLayout>
  );
}

export const NotFoundContainer = () => {
  const { pathname = '', search = '' } = useLocation();
  const { rootDomain } = useStore('appConfig.defaultConfig');
  const routes = useStore('appConfig.routes');
  const [redirect, setRedirect] = useState(false);

  /* Digital Product Marketing (Crystal Maginnes) uses a /u/ in email links if
    don't want to automatically open in Fox Nation app. e.g. /account/u/signup-plans
  */
  const isBrowserLink = pathname.includes('/u/');

  useEffect(() => {
    if (!isBrowserLink) {
      const timer = setTimeout(() => setRedirect(true), REDIRECT_HOME_DELAY);
      return () => {
        clearInterval(timer);
      };
    }
  }, [isBrowserLink, redirect]);

  if (isBrowserLink) {
    const newPath = pathname.replace('/u/', '/');
    return <Navigate replace to={newPath + search} />;
  }

  if (redirect) {
    setLocation(rootDomain);
  }

  /* Change Plans Page was removed, but keeping change plans links since marketing still uses them in emails */
  const preselectMatch = matchPath({ path: routes.changePlansPreselected, exact: true }, pathname);
  if (preselectMatch) {
    //Redirect to the Payment Page (using routes.paymentPreSelectedPlan route)
    return <Navigate replace to={`${routes.payment}/${preselectMatch.params.preSelectedPlan}`} />;
  } else if (pathname.includes(routes.changePlans)) {
    //Redirect to the My Account Page with the change plans modal open
    return <Navigate replace to={routes.myAccount} state={{ showPlanSelectModal: true }} />;
  }

  return <NotFoundComponent title="Page Not Found" subMessage="Redirecting you to Home page" />;
};
